module.exports = __webpack_public_path__ + "static/media/table_w_tablet.32c7ae88.png";